import { createSelector } from 'reselect';
import { Map, List, fromJS } from 'immutable';

const getProducts = store => store.products.data || Map();
const getSearchResult = store => store.globalSearch.results || Map();
const getQuickSearchResult = store => store.quickSearch.results || Map();

const getProductsByArrayOfIds = (store, arrayOfIds = []) =>
  arrayOfIds.reduce((memo, id) => Object.assign({ [id]: store.products.data.get(id) }, memo), {});

const getProductsByFilter = (store, filterKeyArray, filterValue) =>
  store.products.data.filter(item => {
    // If the product does not contain the filterValue, exclude it.
    if (!item.getIn(filterKeyArray)) {
      return false;
    }
    return item.getIn(filterKeyArray).includes(filterValue);
  });

const getProductsByFilters = (store, filterKeyArray, filterValue) =>
  store.products.data.filter(item => {
    // If the product does not contain the filterValue, exclude it.
    if (!item.getIn(filterKeyArray)) {
      return false;
    }
    return item.getIn(filterKeyArray).includes(filterValue);
  });

const getSortOrder = store => store.viewstate.get('sortBy', 'name');
const getSortAscending = store => store.viewstate.get('sortAscending', false);

const getColorFilter = store => store.viewstate.getIn(['filter', 'color'], List()).keySeq();
const getMaterialFilter = store => store.viewstate.getIn(['filter', 'material'], List()).keySeq();
const getManufacturerFilter = store => store.viewstate.getIn(['filter', 'manufacturer'], List()).keySeq();
const getCategoryFilter = store => store.viewstate.getIn(['filter', 'category'], List()).keySeq();

export const getProductsByList = createSelector([getProducts, getSearchResult], (products, searchResult) =>
  products.filter(product =>
    searchResult
      .getIn(['products', 'hits'], List())
      .map(result => result.get('id'))
      .includes(product.get('id'))
  )
);

export const getProductsByArray = createSelector([getProductsByArrayOfIds], products => fromJS(products));

export const getQuickSearchProductsByList = createSelector(
  [getProducts, getQuickSearchResult],
  (products, searchResult) =>
    products.filter(product =>
      searchResult
        .getIn(['products', 'hits'], List())
        .map(result => result.get('id'))
        .includes(product.get('id'))
    )
);

export const getProductsByKey = createSelector([getProductsByFilter], products => products);
export const getProductsByKeys = createSelector([getProductsByFilters], products => products);

const dynamicProductList = (store, productList) => productList;

const checkColorOfVariants = (product, colorFilters) => {
  const matchedVariants = product.get('variants').filter(variant => colorFilters.includes(variant.get('filterColor')));

  return matchedVariants.size > 0;
};

export const getFilteredProducts = createSelector(
  [
    dynamicProductList,
    getColorFilter,
    getMaterialFilter,
    getManufacturerFilter,
    getCategoryFilter,
    getSortOrder,
    getSortAscending
  ],
  (products, colorFilter, materialFilter, manufacturerFilter, categoryFilter, sortOrder, sortAscending) =>
    products
      .filter(p => colorFilter.size === 0 || checkColorOfVariants(p, colorFilter))
      .filter(p => manufacturerFilter.size === 0 || manufacturerFilter.includes(p.getIn(['brand', 'name'])))
      .filter(p => materialFilter.size === 0 || materialFilter.includes(p.getIn(['specifications', 'material'])))
      .filter(p => categoryFilter.size === 0 || categoryFilter.includes(p.getIn(['category', 'name'])))
      .sort((a, b) => {
        const isAString = typeof a.get(sortOrder) === 'string';
        const isBString = typeof b.get(sortOrder) === 'string';
        if (isAString && isBString) {
          const aLowerCase = a.get(sortOrder).toLowerCase();
          const bLowerCase = b.get(sortOrder).toLowerCase();
          if (aLowerCase < bLowerCase) {
            return sortAscending ? 1 : -1;
          } else if (aLowerCase > bLowerCase) {
            return sortAscending ? -1 : 1;
          }
        } else if (a.get(sortOrder) < b.get(sortOrder)) {
          return sortAscending ? 1 : -1;
        } else if (a.get(sortOrder) > b.get(sortOrder)) {
          return sortAscending ? -1 : 1;
        }
        return 0;
      })
);



// WEBPACK FOOTER //
// ./src/selectors/reselectCategory.js